import Avenue1 from "./ruko avenue.webp";
import Avenue2 from "./ruko avenue (2).webp";
import Avenue3 from "./ruko avenue (3).webp";
import Avenue4 from "./ruko avenue (4).webp";

const avenueimages = [Avenue1, Avenue2, Avenue3, Avenue4];

export default avenueimages;
